module.exports = __webpack_public_path__ + "media/D2 Plaza 4.aa5273a7.mp3";